
import React from 'react';
import '../PropertyCategory.css';
import '../../LatestProperties/LatestProperties.css';
import PropertyCard from '../PropertyCard';
import { propertyData } from '../../../data/properties';

const ResidentialPlots = () => {
    const [currentPage, setCurrentPage] = React.useState(1);
    const itemsPerPage = 6;

    const allProperties = propertyData.filter(item => item.category === 'Residential Plots');

    const totalPages = Math.ceil(allProperties.length / itemsPerPage);
    const currentProperties = allProperties.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handlePrevious = () => {
        if (currentPage > 1) setCurrentPage(prev => prev - 1);
    };

    const handleNext = () => {
        if (currentPage < totalPages) setCurrentPage(prev => prev + 1);
    };

    return (
        <section className="category-section">
            <div className="category-header">
                <span className="tag">Build Your Dream</span>
                <h1>Residential Plots</h1>
            </div>

            <div className="category-grid">
                {currentProperties.map((property, index) => (
                    <PropertyCard
                        key={index}
                        image={property.image}
                        badgeSale={property.badgeSale}
                        badgeType={property.badgeType}
                        features={property.features}
                        title={property.title}
                        location={property.location}
                        price={property.price}
                        isCallPrice={property.isCallPrice}
                    />
                ))}
            </div>

            {totalPages > 1 && (
                <div className="pagination-container">
                    <button
                        className="pagination-btn"
                        onClick={handlePrevious}
                        disabled={currentPage === 1}
                    >
                        &laquo; Previous
                    </button>
                    <button
                        className="pagination-btn"
                        onClick={handleNext}
                        disabled={currentPage === totalPages}
                    >
                        Next &raquo;
                    </button>
                </div>
            )}
        </section>
    );
};

export default ResidentialPlots;
